import React, { useState, useEffect } from 'react'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import PropTypes from 'prop-types';
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable';
import PopupHeader from 'Components/PopupHeader/PopupHeader';
import PopupFooter from 'Components/PopupFooter/PopupFooter';
import api from '../../http/index';
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader';
import NoDataFound from 'Common/NoDataFound';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import { formatDateTime } from 'Utils/Utils';
import UserIcon from 'SVGS/UserIcon';
import ClockIcon from 'SVGS/ClockIcon';
import AddendumHistoryItem from '../AddendumPopup/AddendumHistoryItem';

const PaymentNoteHistoryPopup = ({ onClose, disableDraggable, paymentMainNotesId }) => {
    const UNIQUE_ID = "PaymentNoteHistoryPopup"

    const [addendumData, setAddendumData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/patientpayment/v2/FindPaymentNotesAudit?PaymentMainNotesId=${paymentMainNotesId}`);
                setAddendumData(response.data.dataModel?.notes || response.data.dataModel || []);
            } catch (err) {
                ErrorHandlingMessage(err);
            } finally {
                setLoading(false);
            }
        })();
    }, [paymentMainNotesId]);

    return (
        <ReactPortal wrapperId={UNIQUE_ID}>
            {loading && <FullPageLoader allowFullScreen />}
            <div data-te-modal-init className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75" id="exampleModalScrollable" tabIndex={-1} aria-labelledby="exampleModalScrollableLabel" aria-modal="true" data-te-open="true">
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${UNIQUE_ID}`}>
                    <div data-te-modal-dialog-ref className="relative w-[900px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg">
                        <div className='p-10 pt-0'>
                            <PopupHeader uniqueId={UNIQUE_ID} heading="Note History" />
                            <div className="overflow-y-auto max-h-[60vh] p-2">
                                {!addendumData || addendumData.length === 0 ? (
                                    <NoDataFound heading="No Note History Found" />
                                ) : (
                                    <div className="space-y-6">
                                        {addendumData.length > 0 && (
                                            <div>
                                                <h3 className="mb-3 text-lg font-semibold text-gray-800">Original Note</h3>
                                                <div className="p-4 rounded-lg bg-gray-50">
                                                    <p className="mb-3 text-gray-700">{addendumData[0].notes || 'No content available'}</p>
                                                    <div className="flex items-center space-x-4 text-sm text-gray-500">
                                                        <div className="flex items-center">
                                                            <UserIcon size={16} className="mr-1" />
                                                            <span>{addendumData[0].updatedBy || addendumData[0].addedBy || 'Unknown User'}</span>
                                                        </div>
                                                            <span>•</span>
                                                        <div className="flex items-center">
                                                            <ClockIcon size={16} className="mr-1" />
                                                            <span>{formatDateTime(addendumData[0].updatedDate || addendumData[0].addedDate)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {addendumData.length > 1 && (
                                            <div>
                                                <h3 className="mb-3 text-lg font-semibold text-gray-800">Addendums ({addendumData.length - 1})</h3>
                                                <div className="space-y-4">
                                                    {addendumData.slice(1).map((addendum, index) => (
                                                        <AddendumHistoryItem key={addendum.id || addendum.paymentMainNotesId || index} addendum={addendum} index={index} />
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <PopupFooter 
                                onClose={onClose}
                            />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default PaymentNoteHistoryPopup

PaymentNoteHistoryPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    disableDraggable: PropTypes.bool,
    paymentMainNotesId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

